import { Component, Input, ViewChild } from '@angular/core';

import { BankResponseDto, PaidBankTypeEnumText, PaidByEnumText, PurchaseResponseDto } from '@api';

import { DefaultModule, PrimeModule } from '@module';
import { ImageFallback } from '@shared/directives/image-fallback.directive';
import { TranslationsPipe } from '@shared/pipe/translations.pipe';

import { LibModalModule, ModalComponent } from 'pn-core-code';

@Component({
  selector: "e-payment-method",
  standalone: true,
  imports: [DefaultModule, PrimeModule, TranslationsPipe, LibModalModule, ImageFallback],
  templateUrl: "./e-payment-method.component.html",
  styleUrl: "./e-payment-method.component.scss",
})
export class EPaymentMethodComponent {
  @ViewChild("signatureImageUrlModal") signatureImageUrlModal: ModalComponent;
  @Input() purchaseData: PurchaseResponseDto = {} as PurchaseResponseDto;
  @Input() bankData: BankResponseDto = {} as BankResponseDto;
  pidByEnumText = PaidByEnumText;
  paidByEnum = PurchaseResponseDto.PaidByEnum;

  paidBankTypeEnum = PurchaseResponseDto.PaidBankTypeEnum;
  paidBankTypeEnumText = PaidBankTypeEnumText;
}
